import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import "../../../../cssfiles/homepage.css";
import { Stack } from "@mui/material";
import CustomCheckbox from "../../../CommonComponents/CustomCheckbox";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/system";


const DataSwitch = styled(Switch)(({ theme, data }) => ({
  width: "92px",
  height: "28px",
  padding: "0px",
  justifyContent: "center",
  '& .MuiSwitch-switchBase': {
    color: "#B5BFBC",
    padding: "0px",
    justifyContent: "center",
    transition: 'none',
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: "#005C8E"
    },
  },
  '& .MuiSwitch-thumb': {
    color: "#E0E0E0",
    width: "20px",
    height: "20px",
    margin: "4px 5px 4px 5px",
    padding: "0px"
  },
  '& .MuiSwitch-track': {
    borderRadius: "20px",
    backgroundColor: "#005C8E",
    justifyContent: "center",
    opacity: "1 !important",
    '&:after': {
      color: "#E0E0E0",
      fontSize: "11px",
      position: "relative",
      marginLeft: "15px",
      marginTop: "10px",
      paddingTop: "10px",
      content: (data == false) ? '"Historical"' : '""'
    },

  },
  '& .Mui-checked': {
    color: "#005C8E",
    '&: before': {
      color: "#E0E0E0",
      fontSize: "11px",
      position: "relative",
      marginBottom: "3px",
      content: '"Realtime"'
    },

  },
}));

export default function DataTable(props) {
  const [VRdata, settext1] = useState("");
  const [data, setData] = useState(true);


  useEffect(() => {
    var currentdate = new Date();
    var datetime =  currentdate.getFullYear()  + "-"
                    + (currentdate.getMonth()+1 < 10 ? "0"+(currentdate.getMonth()+1) : (currentdate.getMonth()+1)) + "-" 
                    + currentdate.getDate()

    setRows([
      [
        "Asset-1",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-2",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-3",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-4",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-5",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-6",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-7",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-8",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-9",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-10",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-11",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-12",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-13",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
      [
        "Asset-14",
        datetime+" 10:59:43",
        230.45,
        230.53,
        230.32,
        5.34,
        5.22,
        5.46,
        50.02,
        0.98,
        1.35,
        1.43,
        342.56,
        354.67,
      ],
    ]);


    let ws = new WebSocket("wss://ems-cloud-ws.azurewebsites.net");
    ws.addEventListener("open", () => console.log("connected"));
    ws.addEventListener("message", (data) => {
      //console.log("data ",data.data)
      var jsondata = JSON.parse(data.data);
      //console.log("Data1", jsondata);
      //console.log("Data2", jsondata[0].Data["VR_Phase_WL4410"]);
      /* settext1(jsondata.Data["VR_Phase_WL4410"])*/
      setRows([
        [
          "Asset-1",
          new Date(jsondata[0].timestamp * 1000).toLocaleString('en-GB', { timeZone: 'Asia/Kolkata', hour12: false }).replace(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2}):(\d{2})/, '$3-$2-$1 $4:$5:$6'),
          jsondata[0].Data["VR_Phase_WL5010"],
          jsondata[0].Data["VY_PHASE_WL5010"],
          jsondata[0].Data["VB_Phase_WL5010"],
          jsondata[0].Data["Current_R_Phase_WL5010"],
          jsondata[0].Data["Current_Y_Phase_WL5010"],
          jsondata[0].Data["Current_B_Phase_WL5010"],
          jsondata[0].Data["Frequency_WL5010"],
          jsondata[0].Data["PF Average Received_WL5010"],
          jsondata[0].Data["TotalActive Power_WL5010"],
          jsondata[0].Data["Total Apparent Power (kVA)_WL5010"],
          jsondata[0].Data["Active Energy (kWh)_WL5010"],
          jsondata[0].Data["Apparent Energy (kVAh)_WL5010"],
        ],
        [
          "Asset-2",
          new Date(jsondata[1].timestamp * 1000).toLocaleString('en-GB', { timeZone: 'Asia/Kolkata', hour12: false }).replace(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2}):(\d{2})/, '$3-$2-$1 $4:$5:$6'),
          jsondata[1].Data["VR_Phase_WL4410"],
          jsondata[1].Data["VY_PHASE_WL4410"],
          jsondata[1].Data["VB_Phase_WL4410"],
          jsondata[1].Data["Current_R_Phase_WL4410"],
          jsondata[1].Data["Current_Y_Phase_WL4410"],
          jsondata[1].Data["Current_B_Phase_WL4410"],
          jsondata[1].Data["Frequency_WL4410"],
          jsondata[1].Data["PF Average Received_WL4410"],
          jsondata[1].Data["TotalActive Power_WL4410"],
          jsondata[1].Data["Total Apparent Power (kVA)_WL4410"],
          jsondata[1].Data["Active Energy (kWh)_WL4410"],
          jsondata[1].Data["Apparent Energy (kVAh)_WL4410"],
        ],
        [
          "Asset-3",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
        [
          "Asset-4",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
        [
          "Asset-5",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
        [
          "Asset-6",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
        [
          "Asset-7",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
        [
          "Asset-8",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
        [
          "Asset-9",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
        [
          "Asset-10",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
        [
          "Asset-11",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
        [
          "Asset-12",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
        [
          "Asset-13",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
        [
          "Asset-14",
          datetime+" 10:59:43",
          230.45,
          230.53,
          230.32,
          5.34,
          5.22,
          5.46,
          50.02,
          0.98,
          1.35,
          1.43,
          342.56,
          354.67,
        ],
      ]);
    });

    return () => {
      ws.close()
    }
  }, []);

  const head_statustable = [
    "Asset Name",
    "Timestamp",
    "VR",
    "VY",
    "VB",
    "IR",
    "IY",
    "IB",
    "Hz",
    "PF",
    "kW",
    "kVA",
    "kWh",
    "kVAh",
  ];
  const [rows_statustable, setRows] = useState([]);
  //console.log("VRdata outputted ", rows_statustable);

  //Generic variables
  const [table_head, setTableHead] = useState([]);
  const [table_rows, setTableRows] = useState([]);

  useEffect(() => {
    switch (props.widgetprop.widgetname) {
      case "Status Table":
        setTableHead(head_statustable);
        setTableRows(rows_statustable);
        break;
      default:
        setTableHead([]);
        setTableRows([]);
        break;
    }
  }, [rows_statustable]);

  function handleDataSwitchChange(event) {
    setData(!data);
  }

  return (
    <>

      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 10px 10px 0px' }}>
        <DataSwitch onChange={handleDataSwitchChange} data={data} checked={data} />
      </div>


      {table_rows.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            height: "100%",
            paddingLeft: "0px",
            backgroundColor: "var(--secondary-backgroundLK)",
            paddingRight: "0px",
          }}
          elevation={0}
        >
          <Table sx={{ width: "100%" }} size="small">
            {
              <TableHead>
                <TableRow sx={{ border: "0px" }}>
                  {table_head.map((table_head_value) => (
                    <TableCell
                      sx={{
                        fontSize:
                          props.widgetprop.props.extended.tablehead.fontsize,
                        fontWeight:
                          props.widgetprop.props.extended.tablehead.fontweight,
                        color: "var(--grey-variation-tableLK)",
                      }}
                    >
                      {table_head_value}
                      {/* {console.log("table_head_value", table_head_value)} */}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            }
            <TableBody>
              {table_rows.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    height: "9px",
                    "& > *": {
                      borderBottom: "1px solid var(--table-boarder-line)",
                    },
                  }}
                >
                  {/* {console.log("row", row) */}

                  {row.map((row_value, row_index) => (
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        fontSize:
                          props.widgetprop.props.extended.tablerows.fontsize,
                        fontWeight:
                          props.widgetprop.props.extended.tablerows.fontweight,
                        color: "var(--grey-variation-tablerowsLK)",
                      }}
                    >
                      {/* {console.log("row_value", row_value) */}
                      {typeof row_value === 'number' ? row_value.toFixed(2) : row_value}
                      {/* {row_value} */}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
